/** Minimal Formspree API client (POST JSON to https://formspree.io/f/{formId}). */

export type FormspreeError = { field?: string; message: string; code?: string }

export type FormspreeResult = { ok: true } | { ok: false; errors: FormspreeError[] }

export async function submitToFormspree(formId: string, data: Record<string, string>): Promise<FormspreeResult> {
  try {
    const res = await fetch(`https://formspree.io/f/${formId}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(data),
    })
    if (res.ok) return { ok: true }
    const body = (await res.json().catch(() => null)) as { errors?: FormspreeError[]; error?: string } | null
    return { ok: false, errors: body?.errors ?? [{ message: body?.error ?? `HTTP ${res.status}` }] }
  } catch {
    return { ok: false, errors: [{ message: 'network' }] }
  }
}

/** Turns a <form> element into a plain string record. */
export function formToObject(form: HTMLFormElement): Record<string, string> {
  const out: Record<string, string> = {}
  new FormData(form).forEach((value, key) => {
    if (typeof value === 'string') out[key] = value.trim()
  })
  return out
}
